import { Fragment, useEffect, useRef, useState } from "react";
import { Offcanvas } from "bootstrap";
import { useSortBy } from "react-instantsearch";
import { setStoredSortBy, SORTBY_OPTION } from "../../Layout/Common/algoliaInstantLib";

export const SoryByOptionMobile = () => {
  const { options, refine, currentRefinement } = useSortBy({
    items: SORTBY_OPTION,
  });
  const modalRef = useRef(null);
  const modalInstance = useRef(null);
  const [selected, setSelected] = useState(null);

  const handleRefine = (value) => {
    setStoredSortBy(value);
    refine(value);
  };

  useEffect(() => {
    var selectedItem = options.find((i) => i.value == currentRefinement);
    setSelected(selectedItem);
  }, [currentRefinement]);
  useEffect(() => {
    if (modalRef.current) {
      modalInstance.current = new Offcanvas(modalRef.current, {
        backdrop: true,
      });
    }
  }, []);

  const handleShow = () => {
    modalInstance.current?.show();
  };

  const handleHide = () => {
    modalInstance.current?.hide();
  };
  return (
    <Fragment>
      <div className="filter-SortbyMob">
        <button
          className="btn filter-btn manufatureFilter sortbyFilter fw-medium"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#sortbyMobFilter"
          aria-controls="offcanvasBottom"
          onClick={handleShow}
        >
          <span>Sort by </span>:<span id="sortbyFilter-selected">{selected ? selected.label : ""}</span>
          <i className="fa-solid fa-chevron-down" />
        </button>
      </div>

      <div
        className="offcanvas offcanvas-bottom"
        tabIndex={-1}
        id="sortbyMobFilter"
        aria-labelledby="offcanvasBottomLabel"
        ref={modalRef}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title fs-14 fw-bold" id="offcanvasBottomLabel">
            Sortby
          </h5>
          <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" />
        </div>
        <div className="offcanvas-body">
          <div className="manufacture-filter-list">
            {options &&
              options.map((item, index) => (
                <div className="manufacture-filterList-content sortByFilter-content" key={item.id ?? index}>
                  <div className="common-radio-selection">
                    {/* onChange, not onClick - see sortbyOption.jsx: `checked` without onChange is
                        a read-only field to React, and keyboard radio selection fires `change`. */}
                    <input
                      className="form-check-input"
                      type="radio"
                      name="sortByRadioMob"
                      id={item.id}
                      onChange={() => handleRefine(item.value)}
                      checked={item.value == currentRefinement}
                    />
                  </div>
                  <label className="form-check-label" htmlFor={item.id}>
                    {item.label}
                  </label>
                </div>
              ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
};
